import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

export default function AuthLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
